<script setup lang="ts">
import type { Schemas } from "#shopware";
import { CART_ERROR_MESSAGES } from "~/lib/constants";

const { cart, subtotal } = useCart();
const { shippingAddress } = useCheckout();

const errors = computed(() => cart.value?.errors as Schemas["CartError"][]);

const getErrorObject = (error: Schemas["CartError"]) => {
	const modifiedError = { ...error };
	let messageResult = `Onbekende fout ${modifiedError.messageKey}`;

	if (error.key === "shipping-method-blocked-Bezorgen" && subtotal.value > 25) {
		modifiedError.key = "kwb-shipping-method-country-blocked";
		modifiedError.level = 20;
	}

	const messageConstant = CART_ERROR_MESSAGES[modifiedError.messageKey] || CART_ERROR_MESSAGES[modifiedError.key];

	if (messageConstant) {
		if (messageConstant.message.includes("{{country}}")) {
			messageConstant.message = messageConstant.message.replace(
				"{{country}}",
				shippingAddress.value?.country?.name ?? "jouw land"
			);
		}
	}

	if (messageConstant && (messageConstant.message !== null || messageConstant.message !== undefined)) {
		messageResult = messageConstant.message;
	}

	return {
		message: messageResult,
		solution: !error.messageKey || !messageConstant ? undefined : messageConstant.solution,
		level: modifiedError.level,
		key: modifiedError.key
	};
};

const modifiedErrors = computed(() => {
	return Object.values(errors.value ?? {}).map((error) => {
		return getErrorObject(error);
	});
});
</script>

<template v-if="modifiedErrors?.length">
	<div
		v-for="error in modifiedErrors"
		:key="error.key"
		class="p-4 rounded text-sm flex gap-2 items-center"
		:class="{
			'bg-red text-white': error.level === 20,
			'bg-sand': error.level === 10,
			'border border-brown': error.level === 0
		}"
	>
		<SvgIcon name="info" class="min-w-[24px]" />
		<span class="flex flex-col items-start">
			<span>{{ error.message }}</span>
			<component :is="error.solution" />
		</span>
	</div>
</template>
